import anime from 'animejs/lib/anime.es.js';

// Function to check if an element is in view
const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

function isInView(element, offset = 0) {
    const rect = element.getBoundingClientRect();
    return (
        rect.bottom >= -offset &&
        rect.top <= viewportHeight + offset &&
        rect.right >= -offset &&
        rect.left <= viewportWidth + offset
    );
}

// Function to animate number counters
function animateNumberCounters(items) {
    items.forEach(item => {
        const numberElement = item.querySelector('.number');
        if (numberElement) {
            const targetNumber = parseInt(numberElement.getAttribute('data-count'), 10);
            anime({
                targets: numberElement,
                innerHTML: [0, targetNumber],
                round: 1,
                duration: 3000,
                easing: 'easeOutExpo',
                update: function(anim) {
                    const value = Math.round(anim.animations[0].currentValue);
                    numberElement.innerHTML = value < 10 ? `0${value}` : value;
                }
            });
        }
    });
}

// Function to animate elements
function animateElements(container, items) {
    if (isInView(container, -200) && !container.classList.contains('animated')) {
        anime({
            targets: items,
            opacity: [0, 1],
            translateY: [50, 0],
            duration: 2000,
            easing: 'easeOutExpo',
            delay: anime.stagger(150) // Staggering the animation by 150ms for each element
        });
        container.classList.add('animated');
        animateNumberCounters(items); // Animate number counters
    }
}

// Function to initialize animations for a section
function initAnimation(containerSelector, itemSelector) {
    const container = document.querySelector(containerSelector);
    const items = document.querySelectorAll(itemSelector);

    if (container && items.length > 0) {
        // Add scroll event listener
        window.addEventListener('scroll', () => animateElements(container, items));

        // Initial check in case elements are already in view
        animateElements(container, items);
    }
}

// Animate intro section
const intro = document.querySelector('.franchise-intro');
if (intro) {
    const title = intro.querySelector('.title');
    const text = intro.querySelector('.text');
    const counterBox = intro.querySelector('.counter-box');
    const form = intro.querySelector('.form-wrapper');
    anime({
        targets: [title, text, counterBox, form],
        opacity: [0, 1],
        translateY: [100, 0],
        duration: 2000,
        easing: 'easeOutExpo',
        delay: anime.stagger(150)
    });
    animateNumberCounters(counterBox.querySelectorAll('.item')); // Animate number counters in intro section
}

// Initialize animations for both sections
initAnimation('.franchise-process', '.franchise-process .step');
initAnimation('.franchise-reasons', '.franchise-reasons .item');